export default __webpack_public_path__ + "static/Battle_Tartare-858b37173dcc83af85f6550ce20248e8.png";